import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, PLATFORM_ID, Inject, HostListener } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Commons } from '../../../../shared/Commons';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { AlertModalComponent } from '../../../../shared/modals/alert-modal/alert-modal.component';
import { SelectLanguageModalComponent } from '../../../../shared/modals/select-language-modal/select-language-modal.component';
import { SessionService } from '../../../../services/session.service';
import { Router, RouterModule } from '@angular/router';
import { LanguageUtilService } from '../../../../services/language-util.service';
import { CustomersService } from '../../../../services/customers.service';
import { ClientBrowserSessionStorageService } from '../../../../services/client-browser-session-storage.service';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule, UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-admin-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    UpperCasePipe
  ],
  templateUrl: './admin-header.component.html',
  styleUrl: './admin-header.component.scss'
})
export class AdminHeaderComponent implements OnInit, AfterViewInit {

  appName = environment.appName

  PATH_PRODUCT = Commons.PATH_PRODUCT
  PATH_MY_COMPANY = Commons.PATH_MY_COMPANY
  PATH_MY_PURCHASES = Commons.PATH_MY_PURCHASES
  PATH_MY_LICENCES = Commons.PATH_MY_LICENCES
  PATH_MAIN = Commons.PATH_MAIN
  PATH_MY_CUSTOMER = Commons.PATH_MY_CUSTOMER
  PATH_LOGIN = Commons.PATH_LOGIN
  PATH_ADMIN_UI_KIT = Commons.PATH_ADMIN_UI_KIT

  PATH_CONFIG = Commons.PATH_CONFIG_WITH_LIC
  PATH_PUBLICATIONS = Commons.PATH_PUBLICATIONS_WITH_LIC
  PATH_QUOTES = Commons.PATH_QUOTES
  PATH_CLIENTS = Commons.PATH_CLIENTS
  isProduction = environment.production

  getScreenWidth: any;
  mobileWidth: number = Commons.MOBILE_WIDTH
  sessionIsOpen: boolean = false
  sessionObject: any = null
  alertModal: MdbModalRef<AlertModalComponent> | null = null;
  title = 'label.access-link'
  selLangModal: MdbModalRef<SelectLanguageModalComponent> | null = null;
  webmailSite = environment.webmailSite
  enableWebmailSiteLink = environment.enableWebmailSiteLink
  @ViewChild('mainNavbar', { static: true }) mainNavbar!: ElementRef;
  navbarCollapsed = true;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private modalService: MdbModalService,
    private langService: LanguageUtilService,
    private customersService: CustomersService,
    private sessionStorageService: ClientBrowserSessionStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.sessionIsOpen = Commons.sessionIsOpen(sessionStorageService)
    this.sessionObject = Commons.sessionObject(sessionStorageService)
  }

  ngOnInit(): void {
    this.getScreenWidth = this.isBrowser ? window.innerWidth : Commons.MOBILE_WIDTH + 1
  }

  get isBrowser() {
    return Commons.isBrowser(this.platformId);
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      const elements = document.querySelectorAll('.nav-link');

      elements.forEach((element) => {
        element.addEventListener('mousemove', () => {
          element.classList.add('vibrate');
        });

        element.addEventListener('mouseout', () => {
          element.classList.remove('vibrate');
        });
      });
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.getScreenWidth = this.isBrowser ? window.innerWidth : Commons.MOBILE_WIDTH + 1
  }

  toggleNavbar() {
    this.navbarCollapsed = !this.navbarCollapsed;
  }

  openLanguageModal(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    this.selLangModal = this.modalService.open(SelectLanguageModalComponent)
    this.selLangModal.onClose.subscribe((lang: any) => {
      if (lang != this.langService.getLangActive()) {
        this.langService.setLanguage(lang)
        this.isBrowser && window.location.reload();
      }
    });
  }

  closeSession() {
    if (Commons.sessionIsOpen(this.sessionStorageService)) {
      this.sessionService.setUserLoggedIn(false);
      Commons.sessionClose(this.sessionStorageService)
      this.router.navigate([Commons.PATH_MAIN]).then(() => {
        this.isBrowser && window.location.reload();
      });
    }
  }

  getCustomerName() {
    let name = 'NO-NAME'
    if (this.sessionObject.customer) {
      name = this.sessionObject.customer.email
      if (this.sessionObject.customer.personal_data) {
        name = this.sessionObject.customer.personal_data.first_name
        if (this.sessionObject.customer.personal_data.last_name) {
          name = name + ' ' + this.sessionObject.customer.personal_data.last_name
        }
      }
    }
    return name
  }

  getCompanyName() {
    let name = 'NO-NAME'
    if (this.sessionObject.customer) {
      if (this.sessionObject.customer.company) {
        name = this.sessionObject.customer.company.name
      }
    }
    return name
  }

  get withoutCompany() {
    return !!this.sessionObject?.customer && !Commons.validField(this.sessionObject.customer.company);
  }

  toSupport() {
    this.openNewWindow(Commons.PATH_SUPPORT)
  }

  toMyCompany() {
    if (this.withoutCompany) {
      // cierra la sesion para volver a cargar la sesion en el login
      this.openNewWindowWithoutCompany(this.PATH_MY_COMPANY)
    } else {
      this.openNewWindow(this.PATH_MY_COMPANY)
    }
  }

  toPurchases() {
    this.openNewWindow(this.PATH_MY_PURCHASES)
  }

  toLicences() {
    this.openNewWindow(this.PATH_MY_LICENCES)
  }

  openNewWindow(path: string) {
    this.customersService.createTransientAuth().subscribe({
      next: (v) => {
        Commons.openWithExternalToken(this.platformId, path, v.transient_auth)
      },
      error: (e) => {
        this.openModal('label.unknown-error', 'label.unknown-error-contact-retry', Commons.ICON_ERROR)
      },
      complete: () => { }
    })

  }

  getPlan() {
    const planCategory = Commons.getPlan(this.sessionStorageService)
    switch (planCategory) {
      case Commons.LICENCE_TRIAL:
        return 'label.trial-licence'
      case Commons.LICENCE_BASIC:
        return 'label.basic-licence'
      case Commons.LICENCE_MEDIUM:
        return 'label.medium-licence'
      case Commons.LICENCE_PREMIUM:
        return 'label.premium-licence'
      default:
        return 'label.without-licence'
    }
  }

  openNewWindowWithoutCompany(path: string) {
    this.customersService.createTransientAuth().subscribe({
      next: (v) => {
        Commons.openWithExternalToken(this.platformId, path, v.transient_auth)
        this.closeSession()
      },
      error: (e) => {
        this.openModal('label.unknown-error', 'label.unknown-error-contact-retry', Commons.ICON_ERROR)
      },
      complete: () => { }
    })

  }

  openModalWithRedirection(title: string, message: string, icon: string, path: string) {
    this.alertModal = this.modalService.open(AlertModalComponent, {
      data: { title: title, message: message, icon: icon },
    })
    this.alertModal.onClose.subscribe(() => {
      this.openNewWindow(path)
    });
  }

  openModal(title: string, message: string, icon: string) {
    this.alertModal = this.modalService.open(AlertModalComponent, {
      data: { title: title, message: message, icon: icon },
    })
  }

  closeNavbar(): void {
    this.navbarCollapsed = !this.navbarCollapsed;
  }

}
